module.exports = __webpack_public_path__ + "media/img/apple-icon-57x57-9e9afc7b85a6081c51e9b1af0a52a386.png";